import { safeFetchAPI } from '@/api';
import { log, utils } from '@/helpers';
import { Audience } from '@/types';
import { create } from 'zustand';

type AudienceStoreState = {
	loaded: boolean;
	audiences: Audience[];
	audienceMap: Record<string, Audience>;
};

type AudienceStoreActions = {
	loadAudiences: () => Promise<void>;
	setAudience: (id: string, audience: Audience) => void;
};

export const useAudienceStore = create<AudienceStoreState & AudienceStoreActions>((set, get) => ({
	loaded: false,
	audiences: [],
	audienceMap: {},
	loadAudiences: async () => {
		const [audiences, error] = await safeFetchAPI<Audience[]>('/audiences/:uid');
		if (error) {
			utils?.toaster?.addToast?.({
				message: 'Error loading audiences',
				type: 'danger',
			});
			return;
		}
		const audienceMap = (audiences ?? [])?.reduce(
			(acc, audience) => {
				if (audience.id) acc[audience.id] = audience;
				return acc;
			},
			{} as Record<string, Audience>,
		);

		set({ audiences, loaded: true, audienceMap });
	},
	setAudience: (id: string, audience: Audience) => {
		set((state) => {
			const newAudienceMap = { ...state.audienceMap };
			const existingAudience = newAudienceMap[id];
			newAudienceMap[id] = audience;

			if (existingAudience) {
				const index = state.audiences.findIndex((a) => a.id === id);
				if (index !== -1) {
					state.audiences[index] = audience;
				}
			} else {
				state.audiences.push(audience);
			}

			log('setAudience', id, audience);
			return { audienceMap: newAudienceMap, audiences: [...state.audiences] };
		});
	},
}));
